<div class="p-2">
    <adaa-data-table
        #adaaDataTable
        [apiName]="'getTooltips'"
        [titleHeader]="'breadcrumbs.smart-tool-tips.list' | translate"
        [configKey]="Constants.MAIN_TABLE_LIST_CONF_KEY.MANDATORYS"
        [itemTypeId]="Constants.CONSTANT_PERMISSIONS.MANDATORY"
        [enableAdd]="false"
        [enableDeleteAction]="false"
        (actionClicked)="getAction($event)"
    ></adaa-data-table>
</div>
